import React, { useState, useEffect, useCallback, Fragment } from 'react'
import { useEmblaCarousel } from 'embla-carousel/react'
import Button from 'components/Button'
import Icon from 'components/Icon'
import styles from './Carousel.scss'

interface IButton {
  enabled: boolean
  onClick: () => void
}

const NextButton = ({ enabled, onClick }: IButton) => (
  <Button className={styles.arrow} disabled={!enabled} onClick={onClick}>
    <Icon name='arrowRight' size='regular' />
  </Button>
)

const PrevButton = ({ enabled, onClick }: IButton) => (
  <Button className={styles.arrow} disabled={!enabled} onClick={onClick}>
    <Icon name='arrowLeft' size='regular' />
  </Button>
)

export interface ICarousel {
  slides: Array<React.ReactNode>
}

const Carousel = ({ slides }: ICarousel) => {
  const [viewportRef, embla] = useEmblaCarousel({ align: 'center', inViewThreshold: 0.95 })
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla])
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla])
  const onSelect = useCallback(() => {
    if (!embla) return
    setPrevBtnEnabled(embla.canScrollPrev())
    setNextBtnEnabled(embla.canScrollNext())
  }, [embla])

  useEffect(() => {
    if (!embla) return
    embla.on('select', onSelect)
    onSelect()
  }, [embla, onSelect])

  return (
    <div className={styles.container}>
      <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
      <div className={styles.viewport} ref={viewportRef}>
        <div className={styles.cards}>
          {slides.map((slide, index) => (
            <Fragment key={index}>
              <div className={styles.cardContainer}>
                <div className={styles.card}>{slide}</div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
      <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
    </div>
  )
}

export default Carousel
